import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { AssetCatalogActionPage } from "@/modules/asset_catalog/ActionPage";
import { ManufacturersPage } from "@/modules/asset_catalog/ManufacturersPage";
import { AssetCatalogOverviewPage } from "@/modules/asset_catalog/OverviewPage";

const SUBCOMPONENT_KINDS = ["cell", "bms", "bms_c", "motor", "mcu", "dcdc", "vcu", "vcu_c", "cluster", "cluster_c", "tcu"];

/** Asset Catalog (ASSET_CATALOG.md): Overview (all versions, filters, read
 *  drawer) · Batteries · Vehicles · Subcomponents (each: Add new / Edit
 *  existing → template form) · Manufacturers. */
export function AssetCatalogModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/asset-catalog" tabs={[
          { path: "overview", label: "Overview" },
          { path: "batteries", label: "Batteries" },
          { path: "vehicles", label: "Vehicles" },
          { path: "subcomponents", label: "Subcomponents" },
          { path: "manufacturers", label: "Manufacturers" },
        ]} />
      </div>
      <Routes>
      {/* The three action tabs render the SAME component type at the SAME tree
          position, so without a key React RECONCILES instead of remounting:
          props change (the heading did update) while every useState keeps the
          previous tab's value — `pickKind`, `mode`, `editId`. That is exactly
          "the heading of one subpage over the contents of another". The key
          makes each tab a distinct element, so switching mounts a fresh one. */}
        <Route path="overview" element={<AssetCatalogOverviewPage />} />
        <Route path="batteries" element={
          <AssetCatalogActionPage key="batteries" eyebrow="Asset Catalog · Batteries" title="Battery models" kinds={["battery"]}
            desc="A battery model = pack specs + cells + BMS (+ TCU when the BMS is not connected). Activate when every component is active." />} />
        <Route path="vehicles" element={
          <AssetCatalogActionPage key="vehicles" eyebrow="Asset Catalog · Vehicles" title="Vehicle models" kinds={["vehicle"]}
            desc="A vehicle model = platform specs + motor(s), controller(s), optional VCU / cluster / DC-DC, and at most one connectivity source." />} />
        <Route path="subcomponents" element={
          <AssetCatalogActionPage key="subcomponents" eyebrow="Asset Catalog · Subcomponents" title="Subcomponent models" kinds={SUBCOMPONENT_KINDS}
            desc="Cells, BMS, motors, controllers, VCUs, clusters, DC-DC and telematics units. Connected variants are distinct kinds — they carry the modem, BLE and firmware family." />} />
        <Route path="manufacturers" element={<ManufacturersPage />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
